import { errorHandler } from '80.quickConnect.Core/helpers';
import CustomLogger from '80.quickConnect.Core/logger/customLogger';
import { mapQCNotification } from '90.quickConnect.Models/mappings';
import { NotificationTarget, QCNotification } from '90.quickConnect.Models/models';

const tag = '10.quickConnect.app/components/domain/Declaration/helpers/emailParsers/index.ts';

export const emailParse = (serializedEmails: string, logger: CustomLogger): QCNotification => {
  if (!serializedEmails) return mapQCNotification({});
  serializedEmails = serializedEmails.trim();
  if (serializedEmails === '') return mapQCNotification({});

  // serializedEmails peut être au format :
  // 1.Objet JSON
  // 2.Chaîne "sendToMe ¤ email1; email2" OU "sendToMe" (sendToMe ∈ {true,false,1,0,oui,non,...})
  // 3.Chaîne d'emails séparés par ';' ou ',' : "email1; email2, email3"
  // 4.Email unique

  const toBool = (s: string): boolean => /^(1|true|vrai|oui|yes|on)$/i.test(s.trim());

  const toTargets = (arr: string[]): NotificationTarget[] =>
    arr
      .map((e) => e.trim())
      .filter(Boolean)
      .map((e) => ({ target: e }));

  // 1.Objet JSON
  if (serializedEmails.startsWith('{')) {
    try {
      const notificationValueObject = mapQCNotification(JSON.parse(serializedEmails));
      return notificationValueObject;
    } catch (error) {
      errorHandler(tag, error, 'emailParse');
    }
  }

  // 2."sendToMe ¤ emails" OU "sendToMe"
  if (serializedEmails.includes('¤')) {
    const [sendPart, listPart] = serializedEmails.split('¤').map((s) => s.trim());
    const sendToMe = toBool(sendPart);
    if (listPart) {
      const list = listPart
        .split(/[;,]/)
        .map((s) => s.trim())
        .filter(Boolean);
      return mapQCNotification({ sendToMe, selectedTargets: toTargets(list) });
    }
    return mapQCNotification({ sendToMe });
  }

  // 3.Liste d'emails (';' ou ',') ou 4.Email unique
  const pieces = serializedEmails
    .split(/[;,]/)
    .map((s) => s.trim())
    .filter(Boolean);
  if (pieces.length > 1) {
    return mapQCNotification({ selectedTargets: toTargets(pieces) });
  }
  if (pieces.length === 1) {
    return mapQCNotification({
      selectedTargets: [{ target: pieces[0] }],
      searchAllUO: false,
      sendToMe: false,
    });
  }

  return mapQCNotification({});
};
